import React, { useEffect, useState } from "react";
import { Loader, Modal } from "rsuite";
import "./Orders.css";
import { useTranslation } from "react-i18next";
import { get } from "lodash/fp";
import ViewOrders from "./ViewOrders";

const ViewOrdersModal = ({
  orderFilterData,
  rowData,
  openModal,
  setOpenModal,
  ...props
}: {
  orderFilterData?: any;
  rowData?: any;
  openModal: boolean;
  setOpenModal: Function;
}) => {
  const { t } = useTranslation();
  const [loader, setLoader] = useState(false);

  return (
    <div className="modal-container">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          content={t("LOADING")}
          center
          backdrop={true}
        />
      )}
      <Modal
        open={openModal}
        backdrop={false}
        onClose={(e: any) => {
          setOpenModal("");
        }}
        size="lg"
      >
        <Modal.Header>
          <h4>
            <b>
              {t("ORDERS")} {rowData?.name && t("OF")}
            </b>{" "}
            {rowData?.name}
            {rowData?.mobile && " ("}
            {rowData?.mobile}
            {rowData?.mobile && " )"}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <div className="orders">
            <ViewOrders withHeader={false} orderFilterData={orderFilterData} />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ViewOrdersModal;
